<template>
  <v-container id="area" fluid>
    <v-row>
      <v-col cols="12">
        <v-btn color="green" dark small rounded @click="createArea()">
          <v-icon left>mdi-plus</v-icon> Crea nuova area
        </v-btn>
      </v-col>
    </v-row>

    <v-skeleton-loader :loading="loading" transition-group="scale-transition" type="list-item-three-line, list-item-three-line, list-item-three-line">
      <v-row>
        <v-col cols="12" xl="3" lg="3" md="4" sm="6" xs="12" v-for="(area, i) in areas" :key="i">
          <v-card class="mx-auto">
            <v-avatar tile :color="color(i)" height="150px" width="100%"><v-icon color="white" x-large>mdi-folder-cog</v-icon></v-avatar>
            <v-card-title>{{ area.description }}</v-card-title>
            <v-card-subtitle>{{ (area.activities.length == 0) ? 'Nessuna attività configurata' : `${area.activities.length} attività` }}</v-card-subtitle>
            <v-card-actions>
              <v-tooltip bottom v-if="area.editable">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="green" v-on="on" @click="createActivity(area.id)"><v-icon>mdi-plus</v-icon></v-btn>
                </template>
                <span>Aggiungi nuova attività</span>
              </v-tooltip>
              <v-tooltip bottom v-if="area.editable">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="orange" v-on="on" @click="editArea(area)"><v-icon>mdi-circle-edit-outline</v-icon></v-btn>
                </template>
                <span>Modifica area</span>
              </v-tooltip>
              <v-tooltip bottom v-if="area.removable">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="red" v-on="on" @click="askRemoveArea(area)"><v-icon>mdi-delete</v-icon></v-btn>
                </template>
                <span>Rimuovi area</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="area.show = !area.show" :disabled="area.activities.length == 0">
                    <v-icon>{{ area.show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                </template>
                <span>Visualizza attività</span>
              </v-tooltip>
            </v-card-actions>

            <v-expand-transition>
                <div v-show="area.show">
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-chip-group column>
                      <v-chip v-for="activity in area.activities" :key="activity.id" label @click="editActivity(activity, area.id)"
                        close-icon="mdi-delete" :close="activity.removable" @click:close="askRemoveActivity(activity)">
                        {{ activity.description }}
                      </v-chip>
                    </v-chip-group>
                  </v-card-text>
                </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-skeleton-loader>

    <area-form ref="refAreaForm" :area="selectedArea" :isNew="isNewArea" @saved="notify"></area-form>
    <activity-form ref="refActivityForm" :activity="selectedActivity" :areas="areas" :isNew="isNewActivity" @saved="notify"></activity-form>
    <confirm ref="refConfirmArea" :item="deleteArea" @confirmed="removeArea"></confirm>
    <confirm ref="refConfirmActivity" :item="deleteActivity" @confirmed="removeActivity"></confirm>
    <notify ref="refNotify"></notify>
  </v-container>
</template>

<script>
import AreaFormVue from './AreaForm.vue';
import ActivityFormVue from './ActivityForm.vue';
import ConfirmDialogVue from '../dialog/ConfirmDialog.vue';
import NotifyVue from '../dialog/Notify.vue';
import apiRepository from '../../api/api-repository';

export default {
  name: 'AreaView',

  components: {
    'area-form': AreaFormVue, // form di creazione di una nuova area.
    'activity-form': ActivityFormVue, // form di creazione di una nuova attività.
    'confirm': ConfirmDialogVue, // dialog di conferma di un'operazione.
    'notify': NotifyVue, // snackbar di notifica operazioni.
  },

  data: ()=> ({
    loading: true, // flag di caricamento dello skeleton loader.
    isNewArea: true, // flag di gestione del form di creazione/modifica area.
    isNewActivity: true, // flag di gestione del form di creazione/modifica attività.
    areas: new Array(), // lista delle aree caricate alla creazione del componente.
    selectedArea: new Object(), // area selezionata per la creazione/modifica.
    deleteArea: new Object(), // area selezionata per la cancellazione.
    selectedActivity: new Object(), // attività selezionata per la creazione/modifica.
    deleteActivity: new Object(), // attività selezionata per la cancellazione.
    colors: [ 'cyan', 'green', 'orange', 'red', 'purple', 'blue', 'light-blue', 'pink', 'yellow', 'grey' ],
  }),

  methods: {
    async load(){
      let res = await apiRepository.area().findAll(); // attendo il risultato della chiamata.
      res.data.forEach((x)=> x.show = false); // setto il flag di visualizzazione delle attività.
      this.areas = res.data; // carico il risultato della chiamata sulla lista delle aree.
      this.loading = false; // disabilito lo skeleton loader di caricamento.
    },

    createArea(){
      this.isNewArea = true; // setto il form per una creazione.
      this.selectedArea = { code: '', description: '' }; // area vuota per nuova creazione.
      this.$refs.refAreaForm.open(); // apro il form in creazione.
    },

    editArea(area){
      this.isNewArea = false; // setto il form per una modifica.
      this.selectedArea = { id: area.id, code: area.code, description: area.description };
      this.$refs.refAreaForm.open(); // apro il form in modifica.
    },

    askRemoveArea(item){
      this.deleteArea = item; // seleziono l'attività da cancellare.
      let title = 'Conferma cancellazione', message = `Sei sicuro di voler cancellare l'area ${this.deleteArea.description}? L'operazione è irreversibile.`;
      this.$refs.refConfirmArea.confirm(title, message); // apro la confirmbox per la cancellazione.
    },

    async removeArea(answer, item){
      if(!answer) return; // richiesta di cancellazione annullata.
        
      try{
        let res = await apiRepository.area().deleteById(item.id); // richiamo l'api di cancellazione dal servizio.
        this.notify(res); // notifico la riuscita dell'operazione.
      }
      catch(e){
        console.error('exception:', e); // loggo l'errore riscontrato.
        this.notify(e); // notifico l'errore riscontrato.
      }
    },

    createActivity(areaId){
      this.isNewActivity = true;
      this.selectedActivity = { areaId: areaId, description: '' }; // attività vuota per nuova creazione.
      this.$refs.refActivityForm.open(); // apro il form di creazione.
    },

    editActivity(activity, areaId){
      this.isNewActivity = false; // setto il form per una modifica.
      this.selectedActivity = { id: activity.id, areaId: areaId, description: activity.description };
      this.$refs.refActivityForm.open(); // apro il form in modifica.
    },

    askRemoveActivity(item){
      this.deleteActivity = item; // seleziono l'attività da cancellare.
      const title = 'Conferma cancellazione', 
        message = `Sei sicuro di voler cancellare l'attività ${this.deleteActivity.description}? L'operazione è irreversibile.`;
      this.$refs.refConfirmActivity.confirm(title, message); // apro la confirmbox per la cancellazione.
    },

    async removeActivity(answer, item){
      if(!answer) return; // richiesta di cancellazione annullata.

      try{
        let res = await apiRepository.activities().deleteById(item.id); // richiamo l'api di cancellazione dal servizio.
        this.notify(res); // notifico la riuscita dell'operazione.
      }
      catch(e){
        console.error('exception:', e); // loggo l'errore riscontrato.
        this.notify(e); // notifico l'errore riscontrato.
      }
    },

    color(i){
      return (i < this.colors.length) ? this.colors[i] : this.colors[(i - this.colors.length - 1)];
    },

    notify(res){
      this.load(); // ricarico la lista delle aree.
      if(res.success) this.$refs.refNotify.notify('success', res.message); // notifico la riuscita dell'operazione.
      else this.$refs.refNotify.notify('error', res.message); // notifico l'errore riscontrato nell'operazione.
    }
  },

  created(){
    this.load();
  }
}
</script>